<template>
  <div class="mains">
    <div class="campus">
      小程序管理
      <span>></span>系统设置
    </div>
    <div class="xiaoqu">
      <el-card :span="24">
        <div class="grid-content">
          <div class="xiaoqu_1">小程序获取手机号</div>
          <div class="kaiqi xitong_kaiqi">
            <el-switch
              v-model="value"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="updateMiniInfoUserTelSet"
            ></el-switch
            >启用<span class="kaiqi_wenzi"
              >( 此启用为启用自开关，开启后，上传效果将实际应用到用户小程序中
              )</span
            >
          </div>
          <div class="xitong_gnsm">
            <span>
              <span class="xitong_gnsm1"> 功能说明：</span>
              1、开启获取手机号后，学员在小程序端登录使用即会弹出微信手机号授权，未授权手机号的学员无法在小程序端进行学习。仅支持发现页、课程列表页点击课程时获取。
            </span>
            <br />
            <span class="xitong_gnsm2">
              2、由于微信接口限制，该功能只对非个人开发者，且完成了认证的小程序生效（不包含海外主体），如果不符合条件仍然开启该设置项会导致小程序端学员无法使用，请谨慎操作。
            </span>
          </div>
        </div>
      </el-card>
      <el-card class="qiye_zizhi" :span="24">
        <div class="xiaoqu_1">企业资质</div>
        <div class="shenzhong">
          <i class="img_1"> <img src="@/assets/img/education-manage/campus/shenzhong.png" alt /> </i
          >请您慎重选择与企业资质相关的信息，您填写的信息将具备法律效应。
        </div>
        <div class="form_1 right qyzz_jigou">
          <el-form
            ref="forms"
            :model="qiyezizhi"
            :rules="FormRules"
            label-width="5.72917vw"
          >
            <el-form-item label="营业执照编号" prop="license_no">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" class="liuzi" alt />
              </i>
              <el-input
                v-model="qiyezizhi.license_no"
                placeholder="请您输入营业执照编号"
              ></el-input>
            </el-form-item>
            <el-form-item label="企业/机构名称" prop="name" class="qizi">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" class="liuzi1" alt />
              </i>
              <el-input
                v-model="qiyezizhi.name"
                placeholder="请输入企业/机构名称 ( 不超过12字 )"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="tel">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <el-input
                v-model="qiyezizhi.tel"
                placeholder="请您输入固定联系号码，以便联系"
              ></el-input>
            </el-form-item>
            <el-form-item class="shangchuan_lbt" label="营业执照" prop="name">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" class="lbt_shang" alt />
              </i>
              <el-upload
                class="avatar-uploader"
                action="#"
                :show-file-list="false"
                :http-request="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="tempImg" :src="tempImg" class="avatar1" />
                <i v-else class="el-icon-plus avatar-uploader-icon1"></i>
              </el-upload>
              <el-upload
                action="#"
                :show-file-list="false"
                :http-request="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                class="lbt_item"
              >
                <el-button
                  size="small"
                  type="primary"
                  class="genghuan_gnk lbt_btns lbt_btn"
                  >上传图片</el-button
                >
              </el-upload>
              <span class="genghuan_gnk lbt_span1"
                >( 建议：JPG或PNG图片， 推荐：900*500px )</span
              >
            </el-form-item>
            <el-form-item class="queding_xuigai">
              <el-button
                type="primary"
                :loading="loading_1"
                @click="modificatio1"
                >保存设置</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'minisysconfig',
  data () {
    return {
      FormRules: {},
      value: '',
      value1: '',
      id: '',
      qiyezizhi: {},
      tempImg: '',
      loading_1: false
    }
  },
  created () {
    this.miniInfoSetting()
  },
  methods: {
    // 查询系统设置信息
    miniInfoSetting () {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '')
      let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/mini/miniInfo/miniInfoSetting/' + orgid,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token
        }
      })
      pro
        .then(result => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message)
          }
          this.id = result.data.data.id
          if (result.data.data.usertel_set === 1) {
            this.value = true
          } else {
            this.value = false
          }
          this.qiyezizhi = result.data.data.orgInfo
          this.tempImg = this.qiyezizhi.license_url
          console.log(this.value)
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('查询系统设置信息失败：' + err)
        })
    },

    handleAvatarSuccess (data) {
      // console.log(data.file)
      let orgid = window.sessionStorage.getItem('orgid')
      let formData = new FormData()
      formData.append('file', data.file)
      formData.append('orgid', orgid)
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '')
      let pro = this.$http({
        url: '/mini/miniInfo/uploadimage',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token
        }
      })
      pro.then(result => {
        if (result.data.code === 0) {
          let url = result.data.data
          this.tempImg = url
        } else {
          this.$message.error(result.data.message)
        }
      })
        .catch(err => {
          // console.log('error===============')
          this.$message.error('系统错误：' + err)
        })
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      // const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB!')
        return false
      }
      return isJPG && isLt2M
    },

    // 企业资质图片更换
    modificatio1 () {
      this.loading_1 = true
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '')
      let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/mini/miniInfo/updateOrgQualification',
        method: 'POST',
        data: {
          orgid: orgid,
          name: this.qiyezizhi.name,
          license_no: this.qiyezizhi.license_no,
          license_url: this.tempImg,
          tel: this.qiyezizhi.tel
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      })
      pro
        .then(result => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message)
          }
          this.loading_1 = false
          return this.$message.success(result.data.message)
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('企业资质图片更换失败：' + err)
        })
    },

    // 设置获取手机号
    updateMiniInfoUserTelSet () {
      if (this.value === true) {
        this.value1 = 1
      } else {
        this.value1 = 0
      }
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '')
      let pro = this.$http({
        url: '/mini/miniInfo/updateMiniInfoUserTelSet',
        method: 'POST',
        data: {
          id: this.id,
          usertel_set: this.value1
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      })
      pro
        .then(result => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message)
          }
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('设置获取手机号失败：' + err)
        })
    }
  }
}
</script>

<style lang="less">
.qiye_zizhi {
  margin-top: 20px;
  .qyzz_jigou {
    .qizi {
      .el-form-item__label {
        width: 116px !important;
        margin-left: -6px;
      }
      .el-form-item__content {
        margin-left: 110px !important;
      }
    }
    .el-form-item__content {
      margin-left: 110px !important;
    }
    .lbt_btns {
      width: 90px !important;
    }
  }
}

.xitong_kaiqi {
  margin: 25px 10px;
  .kaiqi_wenzi {
    font-size: 14px;
    color: #ccc;
    font-weight: normal;
    margin-left: 20px;
  }
}
.xitong_gnsm {
  font-size: 12px;
  color: #666;
  margin: 0 0 40px 10px;
  position: relative;
  .xitong_gnsm1 {
    font-size: 14px;
    color: #00a6e6;
    margin-bottom: 10px;
  }
  .xitong_gnsm2 {
    margin-left: 73px;
    position: absolute;
    top: 22px;
  }
}
.liuzi {
  left: -118px !important;
}
.liuzi1 {
  left: -122px !important;
}
</style>
